import { number } from 'yup'

const ConditionalNumberRequirement = (conditionalFieldKey, conditionalFieldValue, conditionSchema) => number().when(conditionalFieldKey, {
  is: conditionalFieldValue,
  then: conditionSchema,
  otherwise: number().notRequired()
})

export default ConditionalNumberRequirement
